import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { styleUtils } from '../../../../shared/utils';
import styles from './styles';
import { Text } from "../../../../shared/components/Text";
import {Col, Row} from "../../../../shared/components/View";
import {Form} from "../../../../shared/components";
import {formSchema, validationSchema} from "./schemas";
import {submitEmail} from "../../../../services/onboarding-api";
import Message from "../../../../shared/components/Message";
import {COLORS} from "../../../../shared/design/tokens";

const { style } = styleUtils;
const Container = style('div', styles.container);
const Title = style(Text, styles.title);
const MessageContainer = style(Row, styles.messageContainer);

class ContactUs extends PureComponent {
  constructor(props) {
    super(props);
    const { formData: { contactInformation:{ contactName:name, email, organization} = {}} } = this.props;
    this.state = {
      name,
      email,
      organization,
      message: '',
      status: ''
    }
  }

  handleOnDataChange = (key, value) => {
    const { addToMultiForm } = this.props;
    const {
      name,
      email,
      organization,
      message
    } = this.state;

    this.setState({
      [key]: value
    }, () => {
      addToMultiForm('contact', {name, email, organization, message})
    });
  };

  handleNextStepClick = () => {
    const {name, email, organization, message} = this.state;
    const emailContent = {
      "subject": "BAO Manager - on-boarding order",
      "message": `
          name: ${name}
          email: ${email}
          organization: ${organization}
          message:
          ${message}
        `,
      "recipients": [
        "pmartins+s@baosystems.com",
        "lmatheo+s@baosystems.com",
        email
      ].filter(Boolean)
    };

    submitEmail(emailContent).then(() => {
      const { removeFromMultiForm } = this.props;

      removeFromMultiForm('contact');
      this.setState({
        name: '',
        email: '',
        organization: '',
        message: '',
        status: 'success'
      });
    }).finally(()=> {
      setTimeout(() => this.setState({status: ''}), 5000)
    })
  };

  render() {
    const { t } = this.props;
    const { name, email, organization, message } = this.state;
    const data = {
      message,
      name,
      email,
      organization
    };

    return (
      <Container>
        <Row>
          <Col>
            <Title weight={900}>{t('title')}</Title>
          </Col>
        </Row>
        <Row gutter={50}>
          <Col>
            <Form
              isMultiForm
              formId="contact"
              validationSchema={validationSchema(t, data, true)}
              formSchema={formSchema(t, data, true)}
              onChange={this.handleOnDataChange}
              showMandatoryFieldsLabel={false}
              showMessages={false}
              nextButton={{
                label: t('nextButtonLabel'),
                action: () => this.handleNextStepClick()
              }}
            />
          </Col>
        </Row>
        {
          this.state.status !== "" && (
            <MessageContainer>
                <Message type="success">
                  <Text color={COLORS.MESSAGE.SUCCESS.TEXT} weight={900} size="small">{t('message.success')}</Text>
                </Message>
            </MessageContainer>
          )
        }
      </Container>
    );
  }
}

ContactUs.propTypes = {
  data: PropTypes.object
};

export default ContactUs;
